module.exports = __webpack_public_path__ + "img/odoo-for-help-desk.a95e7518.png";